import {TimesheetFormulaEN} from "./timesheet-formula/en";
import {LeaveSettingEN} from "./annual-leave/en";
import {shiftEN} from "./shift/en";
import {timekeepingSettingEN} from "./timekeeping-setting/en";
import {holidayEN} from "./holiday/en";

export const TimekeepingSettingEN = {
    ...TimesheetFormulaEN,
    ...shiftEN,
    ...LeaveSettingEN,
    ...timekeepingSettingEN,
    ...holidayEN
}